import React from "react";
import PropTypes from "prop-types";
import CouponModel from "./../../model/CouponModel";
import CouponCode from "../couponCode/CouponCode";
import CouponsTC from "../couponsTC/CouponsTC";

export default class Coupons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coupons: [],
      gCoupons: [],
      selectedCoupon: undefined,
      showTermsConditions: false,
      redemptionComplete: false,
    };

    this.scrollContainerRef = React.createRef();

    this.couponModel = new CouponModel();

    // Bindings
    this.setCurrentCoupon = this.setCurrentCoupon.bind(this);
    this.showTerms = this.showTerms.bind(this);
    this.hideTerms = this.hideTerms.bind(this);
    this.completeRedemption = this.completeRedemption.bind(this);
    this.goHome = this.goHome.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.fetchCoupons();
    this.fetchGeneratedCoupons();
  }

  async fetchCoupons() {
    const coupons = await this.couponModel.GetOffers();
    this.setState({ coupons, selectedCoupon: undefined });
  }
  async fetchGeneratedCoupons() {
    const gc = await this.couponModel.GetGeneratedCoupons()
    this.setState({ gCoupons: gc })
}

  setCurrentCoupon(coupon) {
    this.setState({ selectedCoupon: coupon });
  }

  showTerms() {
    this.setState({ showTermsConditions: true });
    this.goNext();
  }

  hideTerms() {
    this.setState({ showTermsConditions: false });    
    if (this.props.onExitCouponFlow) {
      this.props.onExitCouponFlow(); 
    } 
  }

  completeRedemption() {
    console.log("Selected coupon:", this.state.selectedCoupon);
    this.setState({ redemptionComplete: true });
  }

  goHome() {
    
    this.setState({
      selectedCoupon: undefined,
      showTermsConditions: false,
      redemptionComplete: false,
      
    });
    if (this.props.onExitCouponFlow) {
      this.props.onExitCouponFlow(); 
    }    
  }

  goNext() {
    // this.setState({ showCouponsTC: true });
    if (this.props.onEnterCouponFlow) {
      this.props.onEnterCouponFlow(); // ✅ Notify parent to hide points
    }
  }

  handleScroll(e) {
    // Optional: handle scroll if needed
  }

 
  renderCouponsList() {
  
    const { coupons = [], gCoupons = [] } = this.state || {};
    const { coins } = this.props;
    const redeemedOfferIds = Array.isArray(gCoupons) ? gCoupons.map(gc => gc.offer_id): [];

    // const redeemedOfferIds = gCoupons.map(gc => gc.offer_id);
  
    if (coupons.length === 0) {
      return (
        <li key="couponKey-0">
          <label>
            <h5>No coupons available</h5>
          </label>
        </li>
      );
    }
  
    if (!Array.isArray(coupons)) {
      return null; // or return []; or show a message
    }
    
    return coupons.map((coupon) => {
      const isDisabled = coupon.price > coins || redeemedOfferIds.includes(coupon.id);
      const alreadyRedeemed = redeemedOfferIds.includes(coupon.id);
  
      return (
        <li
          key={`couponKey-${coupon.id}`}
          onClick={() => {
            if (!isDisabled) this.setCurrentCoupon(coupon);
          }}
        >
          <div className="coupon-container">
            <input
              type="radio"
              name="company"
              id={`coupon-${coupon.id}`}
              className="input-hidden"
              disabled={isDisabled}
            />
            <label
              htmlFor={`coupon-${coupon.id}`}
              className="coupon-label"
              style={{
                pointerEvents: isDisabled ? "none" : "auto",
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? "default" : "pointer",
              }}
              title={
                coupon.price > coins
                  ? "Not enough coins to redeem"
                  : alreadyRedeemed
                  ? "Coupon already redeemed"
                  : ""
              }
            >
              <img src={coupon.image_url} alt={`Coupon ${coupon.id}`} />
              {coupon.price > coins && (
                <div className="watermark">
                  Not enough points to redeem this coupon
                </div>
              )}
              {alreadyRedeemed && (
                <div className="watermark">
                  You have already redeemed this coupon
                </div>
              )}
            </label>
            <span className="point-box">
              <label id="coupon_price">${coupon.price}</label>
            </span>
          </div>
        </li>
      );
    });
  }
  

  render() {
    const { showTermsConditions, redemptionComplete, selectedCoupon } = this.state;

    if (redemptionComplete) {
      return (
        <CouponCode coupon={selectedCoupon} onHome={this.goHome} />
      );
    }

    return (
      <div className="content step2" id="redeem-step2">
        {showTermsConditions ? (
          <CouponsTC
            onNext={this.completeRedemption}
            onBack={this.hideTerms}
            coupon={selectedCoupon}
          />
        ) : (
          <>
            {/* <h5>Coupons available</h5> */}
            {this.state.coupons.length > 0 && <h5>Coupons available</h5>}

            <div
              ref={this.scrollContainerRef}
              onScroll={this.handleScroll}
              className="contestlist"
            >
              <ul>{this.renderCouponsList()}</ul>
            </div>
            {this.state.coupons.length > 0 && (
              <button
                id="proceed2"
                className="btns"
                onClick={this.showTerms}
                disabled={!selectedCoupon}
                title={!selectedCoupon ? "Please select a coupon" : ""}
              >
                Proceed
              </button>
                            
            )}
          </>
        )}
      </div>
    );
  }
}


